import { render } from "./CardPlanos.vue?vue&type=template&id=1c994307&scoped=true"
import script from "./CardPlanos.vue?vue&type=script&lang=js"
export * from "./CardPlanos.vue?vue&type=script&lang=js"

import "./CardPlanos.vue?vue&type=style&index=0&id=1c994307&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c994307"]])

export default __exports__